import { Sparkles, ShieldCheck, TrendingUp, Gauge } from "lucide-react";

function StatTile({ icon: Icon, label, value, accent }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</span>
        <Icon size={18} className={accent} />
      </div>
      <div className="mt-3 font-mono text-2xl font-bold text-[#0A0F1C]">{value}</div>
    </div>
  );
}

export default function DashboardStats({ profile, matches, planName }) {
  const hasProfile = profile && profile.org_name;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <StatTile icon={Gauge} label="Trust Score" value={hasProfile ? `${profile.trust_score}` : "—"} accent="text-[#2563EB]" />
      <StatTile icon={Sparkles} label="AI Matches" value={matches ? matches.total : "—"} accent="text-[#C2410C]" />
      <StatTile icon={ShieldCheck} label="Verification" value={hasProfile && profile.verified ? "Verified" : "Unverified"} accent="text-[#16A34A]" />
      <StatTile icon={TrendingUp} label="Current Plan" value={planName} accent="text-[#65A30D]" />
    </div>
  );
}
